<div class="row animate fadeIn fast">
    <div class="col-12">
        <div class="card">
            <div class="card-body bg-white">

                <input #txtTermino type="text" class="form-control" placeholder="Search Employee..." (keyup)="buscar( txtTermino.value )" />

            </div>
        </div>
    </div>
</div>


<div class="row animate fadeIn fast" *ngIf="cargando">
    <div class="col-12">

        <div class="alert alert-info text-center">
            <h4 class="alert-heading">Loading</h4>
            <i class="fa fa-refresh fa-spin fa-2x"></i>
            <p class="mb-0">Please wait</p>
        </div>


    </div>
</div>


<!-- *** Tabla de Datos del Empleados -->

<div class="row" *ngIf="!cargando">
    <div class="col-12">
        <div class="card">
            <div class="card-body">

                <div class="row">

                    <div class="col-8">
                        <h4 class="card-title">Employees ({{empleado.length}})</h4>
                        <h6 class="card-subtitle">Employees Registered</h6>
                    </div>

                    <div class="col">
                        <div class="text-right">
                            <a class="btn btn-themecolor rounded-pill" routerLink="/dashboard/employee/nuevo">
                                <i class="fa fa-user mr-2"></i> New Employee
                            </a>
                        </div>
                    </div>

                </div>
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="w100">Photo</th>
                                <th>Info Employee</th>
                                <th class="text-nowrap w100">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of empleado">
                                <td class="text-center">
                                    <img class="w100 pointer" [src]="item.img | imagen: 'employees'" [alt]="item.name" (click)="abrirModal( item )">

                                </td>
                                <td>
                                    <div class="row">
                                        <div class="col-6">
                                            <strong class="mr-2">Full Name:</strong> {{item.name}} {{item.lastname}}
                                        </div>

                                        <div class="col-3">
                                            <strong class="mr-2">Document:</strong>
                                            <span *ngIf="item.tipodoc == 'Cedula Ciudadania'">CC</span>
                                            <span *ngIf="item.tipodoc == 'ID'">ID</span>
                                            <span *ngIf="item.tipodoc == 'Pasaporte'">PS</span>
                                            <span *ngIf="item.tipodoc == 'Passport'">PS</span>
                                            <span *ngIf="item.tipodoc == 'Cedula Extranjeria'">CE</span>
                                            <span *ngIf="item.tipodoc == 'Otro'">#</span>
                                            <span *ngIf="item.tipodoc == 'Other'">#</span> {{item.document}}
                                        </div>
                                        <div class="col-3">
                                            <strong class="mr-2">City: </strong>Bogotá
                                        </div>
                                        <div class="col-12">
                                            <strong class="mr-2">Area:</strong> {{item.area.name}}
                                        </div>
                                        <div class="col-12">
                                            <strong class="mr-2">SubArea:</strong> {{item.subarea.name}}
                                        </div>
                                    </div>
                                </td>

                                <td class="text-nowrap text-center">
                                    <button type="button" class="pointer" [routerLink]="['/dashboard', 'employee', item._id]" data-toggle="tooltip" data-original-title="Editar">
                                        <i class="fa fa-edit text-inverse m-r-10"></i>
                                    </button>
                                    <button type="button" class="pointer" (click)="borrarEmpleado( item )" data-toggle="tooltip" data-original-title="Borrar">
                                        <i class="fa fa-close text-danger"></i>
                                    </button>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                    <!-- **Paginacion -->
                    <ngb-pagination class="float-right" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" [maxSize]="maxSize" [rotate]="true" [ellipses]="false" [boundaryLinks]="false" aria-label="Default pagination" (pageChange)="refresData()"></ngb-pagination>
                </div>

                <!-- <button class="btn btn-secondary btn-sm mr-2">Anterior</button>
                <button class="btn btn-secondary btn-sm">Siguiente</button> -->

            </div>
        </div>
    </div>
</div>